import { Injectable } from '@angular/core';
import { getMessaging, getToken, onMessage, MessagePayload } from 'firebase/messaging';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { getApps } from 'firebase/app';
@Injectable({
  providedIn: 'root',
})
export class FCMService {
  message: MessagePayload | null = null;
  private fcmToken = '';
  private notificationsEnabled = true;
  private notificationSubject = new Subject<MessagePayload>();

  constructor() {
    // this.listenForMessages();
  }

  initializeFCM(): void {
    try {
      if (getApps().length === 0) {
        console.warn('Firebase not initialized yet.');
        return; // Abort if Firebase is not ready
      }

      this.listenForMessages();
      this.requestPermission();
    } catch (err) {
      console.error('Error initializing FCM:', err);
    }
  }

  getNotificationObservable() {
    return this.notificationSubject.asObservable();
  }

  requestPermission(): void {
    const messaging = getMessaging();
    getToken(messaging, { vapidKey: environment.firebase.vapidKey })
      .then((currentToken) => {
        if (currentToken) {
          this.fcmToken = currentToken;
        } else {
          console.log('No registration token available.');
        }
      })
      .catch((err) => {
        console.error('An error occurred while retrieving token:', err);
      });
  }

  getFcmToken(): string {
    return this.fcmToken;
  }

  listenForMessages(): void {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      const notificationTitle = payload.data ? payload.data['title'] : 'No Title';
      if (this.notificationsEnabled) {
        this.showNotification('New notification', notificationTitle, 'info');
      }
      this.notificationSubject.next(payload);
      this.message = payload;
    });
  }

  showNotification(title: string, message: string, type: string) {
    this.playNotificationSound();
    // this.toastService.showToast(type, title, message, 5000);
    console.log(type, title, message, 5000);
  }

  toggleNotifications(status: boolean): void {
    this.notificationsEnabled = status;
  }

  playNotificationSound() {
    const audio = new Audio('assets/sounds/sound.wav');
    audio.play().catch((error) => {
      console.error('Error playing notification sound:', error);
    });
  }
}
